import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { FC } from "react";
import { useState } from "react";
import CancelButton from "../components/cancelButton/CancelButton";
import { sendSms } from "./smsApi";
import SmsCounter from "./SmsCounter";

interface Props {
  readonly phoneNumber: string;
  readonly onClose: () => void;
}

const SendSmsDialog: FC<Props> = ({ phoneNumber, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [content, setContent] = useState("");
  const mutation = useMutation({
    mutationFn: () => sendSms({ phoneNumber, content }),
    onSuccess: () => {
      enqueueSnackbar("SMS został wysłany.", { variant: "success" });
      onClose();
    },
    onError: (error) => enqueueSnackbar(`Nie udało się wysłać SMS. Powód: ${error.message}`, { variant: "error" }),
  });

  return (
    // The dialog renders in a portal, but React still bubbles its events to the clickable card the number sits in.
    <Dialog open onClose={onClose} onClick={(e) => e.stopPropagation()} fullWidth maxWidth="sm">
      <DialogTitle>SMS do {phoneNumber}</DialogTitle>
      <DialogContent>
        <TextField
          label="Treść"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          multiline
          minRows={4}
          fullWidth
          autoFocus
          sx={{ marginTop: 1 }}
        />
        <SmsCounter content={content} />
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose} />
        <Button
          variant="contained"
          disabled={content.trim().length === 0}
          loading={mutation.isPending}
          onClick={() => mutation.mutate()}
        >
          Wyślij
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendSmsDialog;
